import { render } from "./TiltDivider.vue?vue&type=template&id=2f95c596&scoped=true"
import script from "./TiltDivider.vue?vue&type=script&lang=js"
export * from "./TiltDivider.vue?vue&type=script&lang=js"

import "./TiltDivider.vue?vue&type=style&index=0&id=2f95c596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f95c596"]])

export default __exports__